import { Star } from "lucide-react";

export default function StarPicker({ value, onChange, testIdPrefix = "rating" }) {
  return (
    <div className="flex gap-1">
      {[1, 2, 3, 4, 5].map((i) => (
        <button key={i} type="button" onClick={() => onChange(i)} data-testid={`${testIdPrefix}-star-${i}`}
          className="rounded p-0.5 transition-transform duration-150 hover:scale-110">
          <Star className={`h-6 w-6 ${i <= value ? "fill-amber-500 text-amber-500" : "text-slate-600"}`} />
        </button>
      ))}
    </div>
  );
}
